import { render, staticRenderFns } from "./ProcessingPartners.vue?vue&type=template&id=6c495440"
import script from "./ProcessingPartners.vue?vue&type=script&lang=js"
export * from "./ProcessingPartners.vue?vue&type=script&lang=js"
import style0 from "./ProcessingPartners.vue?vue&type=style&index=0&id=6c495440&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports